import type { TOC } from '@ember/component/template-only'

interface Signature {
  Blocks: {
    default: []
  }
}

export const StudentDashboardSubheader: TOC<Signature> = <template>
  <h4 class="mx-3 mt-6 mb-1">
    {{yield}}
  </h4>
</template>

export default StudentDashboardSubheader
